<template>
  <main class="home">
    <div class="title">
      北海道教育大学函館校 青木研究室 Webアプリケーション
      <h1>行列の計算</h1>
    </div>
    <section>
      <h2> 計算 </h2>
      <ul>
	<li> <router-link to="/reduction"> 行列の簡約化 </router-link> </li>
	<li> <router-link to="/equations"> 連立方程式を解く </router-link> </li>
	<li> <router-link to="/inverse"> 逆行列の計算 </router-link> </li>
	<li> <router-link to="/determinant"> 行列式の計算 </router-link> </li>
      </ul>
    </section>
    <section>
      <h2> このアプリについて </h2>
      <h3> 使用法 </h3>
      <p>
	行列の基本変形による簡約化とそれを使った連立方程式の解法、逆行列の計算、さらに行列式の計算を1ステップずつ行ないます。
      </p>
      <p>
	パソコン等キーボードのある端末では、[s]などの[]で囲ったキーを押すことでその項目を選択できます。
	ただし、文字・数値の入力欄がフォーカスされている場合を除きます。
      </p>
      <h3> その他 </h3>
      <p> 開発中のため、計算結果等には誤りがあることもあります。誤りを発見した場合は作者(青木)まで連絡してください。</p>
      <p> This application uses <a href="https://vuejs.org/">vue.js</a>
	and <a href="https://github.com/infusion/Fraction.js">Fraction.js</a>.</p>
    </section>
  </main>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
}
</script>
